import AppLayout from '@/layout/AppLayout.vue';
import { useGAIDEStore } from '@/store/gaideStore';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: AppLayout,
            children: [
                {
                    path: '/',
                    name: 'dashboard',
                    component: () => import('@/views/Dashboard.vue')
                },
                {
                    path: '/certh/blackbox',
                    name: 'certh-blackbox',
                    component: () => import('@/views/certh/Blackbox.vue')
                },
                {
                    path: '/certh/whitebox',
                    name: 'certh-whitebox',
                    component: () => import('@/views/certh/Whitebox.vue')
                },
                {
                    path: '/certh/cbs',
                    name: 'certh-cbs',
                    component: () => import('@/views/certh/CBS.vue')
                },
                {
                    path: '/certh/im-man',
                    name: 'certh-im-man',
                    component: () => import('@/views/certh/ImMan.vue')
                },
                {
                    path: '/certh/lotus',
                    name: 'certh-lotus',
                    component: () => import('@/views/certh/Lotus.vue')
                },
                {
                    path: '/siemens/multi-modal',
                    name: 'siemens-multi-modal',
                    component: () => import('@/views/siemens/Siemens.vue')
                },
                {
                    path: '/siemens/rec-sys',
                    name: 'siemens-rec-sys',
                    component: () => import('@/views/siemens/RecSys.vue')
                },
                {
                    path: '/vicomtech',
                    name: 'vicomtech',
                    component: () => import('@/views/vicomtech/Graph.vue')
                },
                {
                    path: 'atc/hate-speech',
                    name: 'hate-speech',
                    component: () => import('@/views/atc/HateSpeech.vue')
                },
                {
                    path: 'atc/sentiment-analysis',
                    name: 'sentiment-analysis',
                    component: () => import('@/views/atc/Sentiment.vue')
                },
                {
                    path: 'eng/gaide',
                    name: 'engineering-gaide',
                    component: () => import('@/views/eng/Gaide.vue')
                },
                {
                    path: 'eng/gaide/article/:id',
                    name: 'engineering-gaide-article',
                    component: () => import('@/views/eng/Article.vue'),
                    meta: { requiresArticle: true }
                }
            ]
        },
        {
            path: '/pages/notfound',
            name: 'notfound',
            component: () => import('@/views/NotFound.vue')
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/pages/notfound'
        }
    ]
});

router.beforeEach((to, from, next) => {
    const gaideStore = useGAIDEStore();
    if (to.meta.requiresArticle && !gaideStore.selectedArticle) {
        next('/eng/gaide');
    } else {
        next();
    }
});

export default router;
